export function numberToCurrency(x: number | string): string {
  x = Number(x).toFixed(2).toString()
  const pattern = /(-?\d+)(\d{3})/
  while (pattern.test(x)) x = x.replace(pattern, "$1,$2") as string
  return x
}
